
export default function WellTerraSection() {
  const features = [
    {
      icon: 'ri-lightbulb-flash-line',
      title: '複数波長LED',
      description: '赤・青・緑など、目的に応じた波長を選択可能',
    },
    {
      icon: 'ri-shield-check-line',
      title: '安全設計',
      description: '紫外線を含まず、肌に負担をかけにくい設計',
    },
    {
      icon: 'ri-body-scan-line',
      title: '全身ケア対応',
      description: '顔だけでなく、デコルテ・背中・脚など全身に',
    },
    {
      icon: 'ri-home-smile-line',
      title: '大型ドーム型',
      description: 'ゆったりとした空間で、リラックスしながらケア',
    },
  ];

  const recommendations = [
    '肌のコンディションを整えたい方',
    '手軽に継続できるスキンケアを探している方',
    'リラックスしながらケアしたい方',
    'エイジングケアに関心のある方',
    'サロンや施設への導入を検討されている方',
  ];

  return (
    <section id="wellterra" className="py-36 bg-[#1A2B3C] text-white">
      <div className="max-w-[1300px] mx-auto px-10">
        <div className="grid lg:grid-cols-11 gap-16 items-center">
          {/* 左側：コンテンツ */}
          <div className="lg:col-span-6">
            <p className="text-xs font-semibold tracking-widest text-[#50C9C3] mb-5">
              LED LIGHT BEAUTY
            </p>
            <h2 className="text-4xl lg:text-5xl font-bold leading-snug mb-8">
              LED光美容器 WellTerra を活用した<br />
              ウェルビーイング支援
            </h2>
            <p className="text-lg leading-relaxed text-[#B0C4D8] mb-12">
              ドクター監修のLED光美容器を活用した、新しいスキンケア・ボディケアのかたち。<br />
              赤・青・緑など複数波長のLEDによる目的別ケアで、<br />
              肌のコンディションを整え、リラックスした時間をお届けします。
            </p>

            {/* 特徴カード */}
            <div className="grid grid-cols-2 gap-5 mb-14">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="bg-white/8 backdrop-blur-sm rounded-2xl p-6 border border-white/10 hover:bg-white/12 transition-all duration-300"
                >
                  <i className={`${feature.icon} text-2xl text-[#50C9C3] mb-3 block`}></i>
                  <h3 className="text-base font-bold mb-2">{feature.title}</h3>
                  <p className="text-sm text-[#B0C4D8] leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>

            {/* おすすめ */}
            <div className="mb-12">
              <p className="text-sm font-semibold text-[#50C9C3] tracking-wider mb-6">
                RECOMMENDED FOR
              </p>
              <div className="space-y-4">
                {recommendations.map((item, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <i className="ri-checkbox-circle-line text-lg text-[#50C9C3]"></i>
                    <span className="text-[15px] text-[#B0C4D8]">{item}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* CTAボタン */}
            <div className="flex flex-col sm:flex-row gap-4">
              <button className="h-14 px-8 bg-white text-[#1A2B3C] text-base font-semibold rounded-full hover:shadow-xl transition-all duration-300 whitespace-nowrap cursor-pointer">
                体験の流れを見る
              </button>
              <button className="h-14 px-8 bg-transparent border-2 border-white text-white text-base font-semibold rounded-full hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer">
                導入をご検討の方へ
              </button>
            </div>
          </div>

          {/* 右側：ビジュアル */}
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="rounded-[28px] overflow-hidden shadow-2xl">
                <div className="aspect-[4/5] w-full h-full">
                  <img
                    src="https://public.readdy.ai/ai/img_res/172de128023e6af6a2baafc3ea99d956.jpg"
                    alt="WellTerra LED光美容器"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              {/* グロー効果 */}
              <div className="absolute inset-0 rounded-[28px] bg-gradient-to-br from-[#50C9C3]/20 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
